// extracted by css-extract-rspack-plugin
export default {"skeleton":"JVSOVR6rvwtMkd57","skeleton-pulse":"gZTq7IN1hJkJN1N4"};